module.exports = __webpack_public_path__ + "mn.svg?7ff5bebad5607af5a3a0fbedc02f4d37";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/mn.svg
// module id = 1248
// module chunks = 0